const FIRST_STEP_ERROR_KEYS = [
	'arrival_time',
	'departure_time',
	'arrival_date_and_time',
	'arrangement_choices.primary_products',
	'arrangement_choices.secondary_products',
	'arrangement_choices.tertiary_products',
];

const ROOM_CHOICE_ERROR_KEYS = ['arrangement_choices.room_products'];

export type BookingErrorTarget = 'first_step' | 'room_choice_step' | null;

export function resolveBookingErrorTarget(messageKeys: string[]): BookingErrorTarget {
	if (FIRST_STEP_ERROR_KEYS.some((key) => messageKeys.includes(key))) return 'first_step';
	if (ROOM_CHOICE_ERROR_KEYS.some((key) => messageKeys.includes(key))) return 'room_choice_step';

	return null;
}
